import { useSelector } from 'react-redux';
import useCardView from '../../../../hooks/useCardView';
import classnames from 'classnames';
import React from 'react';
import { SaveWasContainerV1 } from './SaveWasContainerV1';
import FormatterV1 from './FormatterV1';
import { MemberPriceContainerV1 } from './MemberPriceContainerV1';

const PricePodV1 = ({
	classes,
	viewModel: {
		NowPrice,
		WasPrice,
		SavePrice,
		RetailPriceIncVat,
		RetailPriceSavings,
		MemberPrice,
		ProductMemberPriceFinanceQuote,
		upfrontPaymentAmount,
	} = {},
	inStock,
	FullTitle,
	Promotions: { FinancePromotions } = {},
	Code,
	ColourId,
	State,
}) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isListView } = useCardView();
	if (!NowPrice) {
		return null;
	}

	const dealAvailable = SavePrice > 0 || RetailPriceSavings > 0;

	const displayWasPrice = WasPrice > 0 && SavePrice > 0;
	const displayMemberPrice = MemberPrice > 0;

	const was = displayWasPrice ? WasPrice : RetailPriceIncVat;
	const save = displayWasPrice ? SavePrice : RetailPriceSavings;

	return (
		<div
			className={classnames(classes, {
				'mt-2 md:mt-0': !isDealsPage,
				'flex flex-col mb-1': isDealsPage,
				'lg:justify-end': isDealsPage && isListView,
			})}>
			{displayMemberPrice && (
				<MemberPriceContainerV1
					memberPrice={MemberPrice}
					nowPrice={NowPrice}
					was={was}
					save={save}
					ProductMemberPriceFinanceQuote={ProductMemberPriceFinanceQuote}
					inStock={inStock}
					Code={Code}
					ColourId={ColourId}
					financeType={null}
					State={State}
					FinancePromotions={FinancePromotions}
					productTitle={FullTitle}
					useOldPricePod={true}
					upfrontPaymentAmount={upfrontPaymentAmount}
				/>
			)}

			{displayMemberPrice ? (
				<div className="flex flex-col mt-2 lg:mt-0 2xl:mt-2 items-baseline">
					<span className="text-title-sm pl-3 mb-1">Non-member price</span>
					<div className="flex lg:flex-col xl:flex-row items-baseline">
						<div
							className={classnames('text-left', {
								'h-6 md:h-auto': was && save,
								'text-deals': dealAvailable,
								'text-display-lg': isDealsPage,
								'text-title-lg lg:text-xl main-price mb-1': !isDealsPage,
								'lg:text-title-lg': isDealsPage && isListView,
								'text-primary md:mr-0 ml-3': displayMemberPrice,
							})}
							data-testid="price-now">
							{FormatterV1.format(NowPrice)}
						</div>

						{was > 0 && save > 0 && (
							<SaveWasContainerV1
								{...{ was, save, displayWasPrice, displayMemberPrice }}
							/>
						)}
					</div>
				</div>
			) : (
				<div className="flex mt-2 lg:mt-0 2xl:mt-2 items-baseline lg:flex-col xl:flex-row">
					<div
						className={classnames('text-left pr-1', {
							'h-6 md:h-auto': was && save,
							'text-deals': dealAvailable,
							'text-display-lg': isDealsPage,
							'text-title-lg lg:text-xl main-price mb-1': !isDealsPage,
							'lg:text-title-lg': isDealsPage && isListView,
							'text-primary md:mr-0 pl-2': displayMemberPrice,
						})}
						data-testid="price-now">
						{FormatterV1.format(NowPrice)}
					</div>

					{was > 0 && save > 0 && (
						<SaveWasContainerV1
							{...{ was, save, displayWasPrice, displayMemberPrice }}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default PricePodV1;
